import { NgModule } from '@angular/core';
import { UnsavedChangesWarningDialogComponent } from './unsaved-changes-warning-dialog.component';
import { CommonModule } from '@angular/common';
import { SiModalModule } from '../si-modal';
import {  MatButtonModule } from '@angular/material/button';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,CommonModule, SiModalModule, MatButtonModule],
    declarations: [UnsavedChangesWarningDialogComponent],
    exports: [UnsavedChangesWarningDialogComponent, SiModalModule, MatButtonModule],
})
export class UnsavedChangesWarningDialogModule { }
